import { Component, OnDestroy, OnInit, HostBinding, HostListener, ViewEncapsulation, Inject } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';

import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

import { AuthenticationService } from 'app/auth/service';
import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import { CoreConfigService } from '@core/services/config.service';
import { CoreMediaService } from '@core/services/media.service';

import { User } from 'app/auth/models';

import { coreConfig } from 'app/app-config';
import { Router } from '@angular/router'; 
import { localStorageService } from '@core/services/local-storage.service';
import { DOCUMENT } from '@angular/common';



@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NavbarComponent implements OnInit, OnDestroy {
  public horizontalMenu: boolean;
  public hiddenMenu: boolean;
currentUser!: User;
  displayName = '';
  displayEmail = '';
  public coreConfig: any;
  public currentSkin: string;
  public prevSkin: string;

  // public currentUser: User;

  public languageOptions: any;
  public navigation: any;
  public selectedLanguage: any;
  lang: any;
  currentLang: string;

  @HostBinding('class.fixed-top')
  public isFixed = false;

  @HostBinding('class.navbar-static-style-on-scroll')
  public windowScrolled = false;

  // Add .navbar-static-style-on-scroll on scroll using HostListener & HostBinding
  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (
      (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop > 100) &&
      this.coreConfig.layout.navbar.type == 'navbar-static-top' &&
      this.coreConfig.layout.type == 'horizontal'
    ) {
      this.windowScrolled = true;
    } else if (
      (this.windowScrolled && window.pageYOffset) ||
      document.documentElement.scrollTop ||
      document.body.scrollTop < 10
    ) {
      this.windowScrolled = false;
    }
  }

  

  // Private
  private _unsubscribeAll: Subject<any>;

  /** 
   * Constructor
   *
   * @param {Router} _router
   * @param {AuthenticationService} _authenticationService
   * @param {CoreConfigService} _coreConfigService
   * @param {CoreSidebarService} _coreSidebarService
   * @param {CoreMediaService} _coreMediaService
   * @param {MediaObserver} _mediaObserver
   * @param {TranslateService} _translateService
   */
  constructor(
    private _router: Router,
    private _authenticationService: AuthenticationService,
    private _coreConfigService: CoreConfigService,
    private _coreMediaService: CoreMediaService,
    private _coreSidebarService: CoreSidebarService,
    private _mediaObserver: MediaObserver,
    public _translateService: TranslateService,
    private localStorage: localStorageService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this._authenticationService.currentUser.subscribe(x => (this.currentUser = x));

  
    this.languageOptions = {
      en: {
        title: 'English',
        flag: 'us',
      },
      ar: {
        title: 'العربية',
        flag: 'ae',
      },
    };
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  // Public Methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Toggle sidebar open
   *
   * @param key
   */
  toggleSidebar(key): void {
    this._coreSidebarService.getSidebarRegistry(key).toggleOpen();
  }

  /**
   * Set the language
   *
   * @param language
   */
  setLanguage(lang: string): void {
  
    this._translateService.use(lang);
    this.currentLang = lang;
    this.localStorage.setItem('currentLang', lang);
  
    // Update the `dir` attribute
    const htmlTag = this.document.getElementsByTagName('html')[0] as HTMLHtmlElement;  
    
    htmlTag.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
    htmlTag.style.direction = lang === 'ar' ? 'rtl' : 'ltr';
    htmlTag.style.textAlign = lang === 'ar' ? 'right' : 'left';

    
 
  }
  
  
  
  /**
   * Toggle Dark Skin
   */
  toggleDarkSkin() {
    // Get the current skin
    this._coreConfigService
      .getConfig()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(config => {
        this.currentSkin = config.layout.skin;
      });

    // Toggle Dark skin with prevSkin skin
    this.prevSkin = localStorage.getItem('prevSkin');

    if (this.currentSkin === 'dark') {
      this._coreConfigService.setConfig(
        { layout: { skin: this.prevSkin ? this.prevSkin : 'default' } },
        { emitEvent: true }
      );
    } else {
      localStorage.setItem('prevSkin', this.currentSkin);
      this._coreConfigService.setConfig({ layout: { skin: 'dark' } }, { emitEvent: true });
    }
  }

  /**
   * Logout method
   */
  logout() {
    this._authenticationService.logout();
    this._router.navigate(['/pages/authentication/login-v2']);
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {

 const userData = localStorage.getItem('user');

    if (userData) {
      this.currentUser = JSON.parse(userData);

      this.displayEmail = this.currentUser.email || '';

      // كوّن الاسم حسب الموجود في الـ model
      if ((this.currentUser as any).name) {
        this.displayName = (this.currentUser as any).name;
      } else if ((this.currentUser as any).username) {
        this.displayName = (this.currentUser as any).username;
      } else if ((this.currentUser as any).first_name) {
        this.displayName =
          `${(this.currentUser as any).first_name} ${(this.currentUser as any).last_name || ''}`;
      } else {
        this.displayName = 'User';
      }
    }
    console.log(this.languageOptions); // Should only contain 'en' and 'ar'
  console.log(this._translateService.getLangs()); 

      // Get the saved language or fallback to default
  const savedLang = this.localStorage.getItem('currentLang') || 'en';
  this.setLanguage(savedLang);


    // get the currentUser details from localStorage
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));

    // Subscribe to the config changes
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
      this.horizontalMenu = config.layout.type === 'horizontal';
      this.hiddenMenu = config.layout.menu.hidden === true;
      this.currentSkin = config.layout.skin;

      // Fix: for vertical layout if default navbar fixed-top than set isFixed = true
      if (this.coreConfig.layout.type === 'vertical') {
        setTimeout(() => {
          if (this.coreConfig.layout.navbar.type === 'fixed-top') {
            this.isFixed = true;
          }
        }, 0);
      }
    });
  
    // Horizontal Layout Only: Add class fixed-top to navbar below large screen
    if (this.coreConfig.layout.type == 'horizontal') {
      // On every media(screen) change
      this._coreMediaService.onMediaUpdate.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
        const isFixedTop = this._mediaObserver.isActive('bs-gt-xl');
        if (isFixedTop) {
          this.isFixed = false;
        } else {
          this.isFixed = true;
        }
      });
    }

    // Set the selected language from default languageOptions
    this.selectedLanguage = _.find(this.languageOptions, {
      id: this._translateService.currentLang
    });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

    getUserImage(): string {
    // backend مش راجع صورة → نستخدم صورة افتراضية
    return 'assets/images/newlogo.png';
  }

  onImgError(event: any) {
    event.target.src = 'assets/images/newlogo.png';
  }
}
